module.exports = __webpack_public_path__ + "page-92d620f2/Background_01_7x2_a-863d5f3ac02162689146d27bef34552b.svg";